import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Button,
    Input,
    Select,
    Space,
    InputNumber, DatePicker, Drawer, Form,
    Typography
} from "antd";
import { filterOption, formatInputNumber, parseInputNumber } from "../../../utils/funcHelper";
import { FORMAT_DATE, STATUS_SERVICES, TYPE_COMMISSION, TYPE_MODAL, TYPE_TICKET } from "../../../constants/constants";

import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import dayjs from "../../../utils/dayjsConfig";
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const { Title, Text } = Typography;
const { Option } = Select;
const ServiceDetailDrawer = ({ isOpen, services, onSave, type, onClose, randomID, data }) => {
    const [form] = Form.useForm();
    const [typeUnit, setTypeUnit] = useState(TYPE_TICKET[0].value);

    // Hàm tính toán thành tiền
    const calculateTotalAmount = (values, unit) => {
        const {
            sale_price = 0,
            total_sessions = 0,
            discount = 0,
            discount_type = TYPE_COMMISSION[1].value,
            paid_amount = 0,
        } = values;
        const type_unit = unit || typeUnit;
        const parsedDiscount = parseFloat((discount || "0").toString().replace(/,/g, ""));
        const parsedSalePrice = parseFloat((sale_price || "0").toString().replace(/,/g, ""));
        const parsedTotalSessions = parseInt(total_sessions || 0);
        const parsedPaidAmount = parseInt((paid_amount || "0").toString().replace(/,/g, ""));
        // Buổi: đơn giá * số buổi
        // Liệu trình: đơn giá là tổng gói, KHÔNG nhân số buổi
        let total =
            type_unit === TYPE_TICKET[2].value
                ? parsedSalePrice
                : parsedSalePrice * parsedTotalSessions;

        if (discount_type === TYPE_COMMISSION[0].value) {
            // Giảm theo %
            total -= (total * parsedDiscount) / 100;
        } else {
            // Giảm cố định
            total -= parsedDiscount;
        }
        form.setFieldsValue({
            remaining_amount: total > 0 ? total - parsedPaidAmount : 0,
        });
        return total > 0 ? total : 0; // Không âm
    };

    // Hàm xử lý khi form thay đổi
    const handleFormChange = (changedValues, allValues) => {
        consoleLogUtil("Form Values:", allValues);
        if (changedValues.service_id) {
            form.setFieldsValue({ status: STATUS_SERVICES[0].value });
        }

        // Tính lại thành tiền khi các trường liên quan thay đổi
        const totalAmount = calculateTotalAmount(allValues);
        form.setFieldsValue({ total_amount: totalAmount });
    };

    // Hàm xử lý khi thay đổi service_id
    const handleServiceChange = (serviceId) => {
        const selectedService = services.find((service) => service.id === serviceId);

        if (selectedService) {
            form.setFieldsValue({
                sale_price: selectedService.price || 0,
                total_sessions: null,
                discount: 0,
                discount_type: TYPE_COMMISSION[1].value,
                type: null,
                total_amount: calculateTotalAmount({
                    sale_price: selectedService.price || 0,
                    total_sessions: 0,
                    discount: 0,
                    discount_type: TYPE_COMMISSION[1].value,
                }),
            });
        }
    };
    // Hàm xử lý khi thay đổi số tiền khách đã trả
    const handleChangePaidAmount = (value) => {
        consoleLogUtil("Changed Paid Amount:", value);
        // Tính lại số tiền còn lại với giá trị mới
        const totalAmount = form.getFieldValue('total_amount') || 0;
        const remainingAmount = totalAmount - (value || 0);
        form.setFieldsValue({ remaining_amount: remainingAmount >= 0 ? remainingAmount : 0 });
    }

    // Hàm xử lý khi thay đổi đơn giá
    const handleChangePrice = (value) => {
        consoleLogUtil("Changed Price:", value);
        // Tính lại thành tiền với giá trị mới
        const allValues = form.getFieldsValue(); // Lấy toàn bộ giá trị hiện tại của form
        const totalAmount = calculateTotalAmount({ ...allValues });
        form.setFieldsValue({ total_amount: totalAmount });
    }

    // Hàm xử lý khi thay đổi số buổi
    const handleChangeTotalSessions = (value) => {
        consoleLogUtil("Changed Total Sessions:", value);
        // Tính lại thành tiền với giá trị mới
        const allValues = form.getFieldsValue(); // Lấy toàn bộ giá trị hiện tại của form
        const totalAmount = calculateTotalAmount({ ...allValues });
        form.setFieldsValue({ total_amount: totalAmount });
    }

    // Hàm xử lý khi thay đổi đơn vị tính
    const handleUnitChange = (value) => {

        setTypeUnit(value);

        let updatedValues = {
            total_sessions: null,
        };
        // Cập nhật giá trị mới vào form
        form.setFieldsValue(updatedValues);

        // Tính lại thành tiền với giá trị mới
        const allValues = form.getFieldsValue(); // Lấy toàn bộ giá trị hiện tại của form
        const totalAmount = calculateTotalAmount({ ...allValues, ...updatedValues }, value);
        form.setFieldsValue({ total_amount: totalAmount });
    };

    const onFinish = (values) => {
        if (type === TYPE_MODAL.EDIT) {
            const updatedService = {
                ...data,
                service_id: values.service_id,
                service_name: services.find(s => s.id === values.service_id)?.name || 'N/A',
                ticket_type_name: TYPE_TICKET.find(t => t.value === values.type)?.label || 'N/A',
                ticket_type: values.type,
                sale_price: values.sale_price,
                discount: values.discount,
                discount_type: values.discount_type,
                quantity: values.total_sessions,
                start_date: (values.dateTime && values.dateTime[0] ? values.dateTime[0].format(FORMAT_DATE.YYYYMMDD) : null),
                end_date: (values.dateTime && values.dateTime[1] ? values.dateTime[1].format(FORMAT_DATE.YYYYMMDD) : null),
                total_amount: values.total_amount,
                paid_amount: values.paid_amount,
                status: values.status,
                note: values.note,
                regis_date: values.regis_date ? values.regis_date.format(FORMAT_DATE.YYYYMMDDHHMMSS) : null,
            }
            onSave(updatedService);
        } else {
            form.validateFields()
                .then((values) => {
                    consoleLogUtil("Form Values on Save:", values);
                    const newService = {
                        id: Date.now(), // Hoặc sử dụng một ID duy nhất khác
                        service_id: values.service_id,
                        service_name: services.find(s => s.id === values.service_id)?.name || 'N/A',
                        ticket_type_name: TYPE_TICKET.find(t => t.value === values.type)?.label || 'N/A',
                        ticket_type: values.type,
                        sale_price: values.sale_price,
                        discount: values.discount,
                        discount_type: values.discount_type,
                        total_sessions: values.total_sessions,
                        start_date: (values.dateTime && values.dateTime[0] ? values.dateTime[0].format(FORMAT_DATE.YYYYMMDD) : null),
                        end_date: (values.dateTime && values.dateTime[1] ? values.dateTime[1].format(FORMAT_DATE.YYYYMMDD) : null),
                        total_amount: values.total_amount,
                        paid_amount: values.paid_amount,
                        status: values.status,
                        note: values.note,
                        regis_date: values.regis_date ? values.regis_date.format(FORMAT_DATE.YYYYMMDDHHMMSS) : null,
                    };
                    onSave(newService);
                })
        }
    }
    useEffect(() => {
        if (type === TYPE_MODAL.ADD) {
            form.resetFields();
            setTypeUnit(TYPE_TICKET[0].value);
            form.setFieldsValue({
                regis_date: dayjs(),
            });
        } else if (type === TYPE_MODAL.EDIT && data) {
            form.setFieldsValue({
                ...data,
                dateTime: [dayjs(data.start_date, 'DD/MM/YYYY'), dayjs(data.end_date, 'DD/MM/YYYY')],
                service_id: data.service_id,
                type: data.ticket_type,
                total_sessions: data.total_sessions,
                sale_price: data.sale_price,
                discount: data.discount,
                discount_type: data.discount_type,
                total_amount: data.total_amount,
                status: data.status ?? STATUS_SERVICES[0].value,
                regis_date: data.regis_date ? dayjs(data.regis_date) : null,
                note: data.note,
            });
            setTypeUnit(data.ticket_type || TYPE_TICKET[0].value);
        }
    }, [type, randomID]);
    return (
        <Drawer
            title={type === TYPE_MODAL.ADD ? "Thêm dịch vụ" : "Cập nhật dịch vụ"}
            width={600}
            onClose={onClose}
            open={isOpen}
            styles={{
                body: {
                    paddingBottom: 80,
                },
            }}
            extra={null
            }
        >
            <Form
                layout="vertical"
                form={form}
                onValuesChange={handleFormChange}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={8}>
                        <Form.Item
                            label="Ngày đăng ký"
                            name={"regis_date"}
                            rules={[{ required: true, message: 'Vui lòng chọn ngày đăng ký' }]}
                        >
                            <DatePicker
                                style={{ width: "100%" }}
                                format={FORMAT_DATE.DDMMYYYYHHMMSS}
                                showTime
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={18}>
                        <Form.Item
                            name="service_id"
                            label="Chọn dịch vụ"
                            rules={[{ required: true, message: 'Vui lòng chọn dịch vụ' }]}
                        >
                            <Select placeholder="Chọn dịch vụ"
                                showSearch
                                filterOption={filterOption}
                                options={services}
                                onChange={(value, option) => handleServiceChange(value, option)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="type"
                            label="Đơn vị tính"
                            rules={[{ required: true, message: 'Vui lòng chọn loại' }]}
                        >
                            <Select
                                placeholder="Chọn đơn vị"
                                onChange={handleUnitChange}
                                options={TYPE_TICKET.filter(item => item.value !== 'monthly')}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>

                    <Col span={12}>
                        <Form.Item
                            name="dateTime"
                            label="Hạn sử dụng"
                            rules={[{ required: true, message: 'Vui lòng chọn ngày' }]}
                        >
                            <DatePicker.RangePicker
                                style={{ width: "100%" }}
                                format={FORMAT_DATE.DDMMYYYY}
                            />

                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="discount_type"
                            label="Loại giảm giá"
                            rules={[{ required: true, message: 'Vui lòng chọn loại giảm giá' }]}
                        >
                            <Select
                                style={{ width: '100%', textAlign: 'center', height: 32, display: 'block' }}
                                options={TYPE_COMMISSION}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="discount"
                            label="Giảm giá"
                        >
                            <InputNumber
                                defaultValue={0}
                                min={0}
                                className="input-number-cus-ant cus-input-number"
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={4}>
                        <Form.Item
                            name="total_sessions"
                            label="Số buổi"
                            rules={[{ required: true, message: 'Vui lòng nhập số buổi' }]}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                min={1}
                                onChange={handleChangeTotalSessions}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item

                            name="sale_price"
                            label="Đơn giá (vnđ)"
                            rules={[{ required: true, message: 'Vui lòng nhập đơn giá' }]}
                        >
                            <InputNumber
                                className="cus-input-number"
                                style={{ width: '100%' }}
                                min={0}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                                onChange={handleChangePrice}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            name="total_amount"
                            label="Thành tiền (vnđ)"
                            rules={[{ required: true, message: 'Vui lòng nhập thành tiền' }]}
                        >
                            <InputNumber
                                className="cus-input-number"
                                style={{ width: '100%', height: 32 }}
                                disabled
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={7}>
                        <Form.Item

                            name="paid_amount"
                            label="Khách đã trả"
                            rules={[{ required: true, message: 'Vui lòng nhập số tiền' }]}
                        >
                            <InputNumber
                                className="cus-input-number"
                                style={{ width: '100%' }}
                                min={0}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                                onChange={handleChangePaidAmount}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={7}>
                        <Form.Item
                            name="remaining_amount"
                            label="Số tiền Còn lại"
                        >
                            <InputNumber
                                className="cus-input-number"
                                style={{ width: '100%' }}
                                min={0}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                                disabled
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <Form.Item
                            name="status"
                            label="Trạng thái"
                            rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
                        >
                            <Select
                                placeholder="Chọn trạng thái"
                                options={STATUS_SERVICES}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="note"
                            label="Ghi chú"
                        >
                            <Input.TextArea rows={4} placeholder="Nhập ghi chú" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Space>
                            <Button onClick={onClose}>Đóng</Button>
                            <Button type="primary" htmlType="submit">
                                Lưu
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    )
}

export default ServiceDetailDrawer;